import { useQuery } from '@tanstack/react-query'
import { PeriodType } from '../../types/statistics.types'
import { statisticsService } from '../service/statistics.service'

export const STATISTICS_KEYS = {
    dashboard: (period: PeriodType) => ['statistics', 'dashboard', period] as const,
    districts: (period: PeriodType) => ['statistics', 'districts', period] as const,
    problems: (period: PeriodType) => ['statistics', 'problems', period] as const,
    monthlyTrend: ['statistics', 'monthly-trend'] as const,
    sourceDistribution: (period: PeriodType) => ['statistics', 'source-distribution', period] as const, 
    dailySummary: ['statistics', 'daily-summary'] as const, 
}

const STALE_TIME = 1000 * 60 * 5

export const useStatisticsDashboard = (period: PeriodType = '30days') => {
	return useQuery({
		queryKey: STATISTICS_KEYS.dashboard(period),
		queryFn: () => statisticsService.getDashboard(period),
		staleTime: STALE_TIME,
	})
}

export const useDistrictStats = (period: PeriodType = '30days') => {
	return useQuery({
		queryKey: STATISTICS_KEYS.districts(period),
		queryFn: () => statisticsService.getDistrictStats(period),
		staleTime: STALE_TIME,
		select: data => [...data].sort((a, b) => b.total - a.total),
	})
}

export const useProblemStats = (period: PeriodType = '30days') => {
	return useQuery({
		queryKey: STATISTICS_KEYS.problems(period),
		queryFn: () => statisticsService.getProblemStats(period),
		staleTime: STALE_TIME,
	})
}

export const useMonthlyTrend = () => {
	return useQuery({
		queryKey: STATISTICS_KEYS.monthlyTrend,
		queryFn: () => statisticsService.getMonthlyTrend(),
		staleTime: STALE_TIME,
	})
}

export const useSourceDistribution = (period: PeriodType = '30days') => {
    return useQuery({
        queryKey: STATISTICS_KEYS.sourceDistribution(period),
        queryFn: () => statisticsService.getSourceDistribution(period),
        staleTime: STALE_TIME,
    })
}

export const useDailySummary = () => {
    return useQuery({
        queryKey: STATISTICS_KEYS.dailySummary,
        queryFn: () => statisticsService.getDailySummary(),
        staleTime: 1000 * 60 * 1, 
    })
}
